import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { Link, NavLink } from "react-router-dom";
import { fetchAffiliates } from "@/lib/api/resources/affiliates";
import { EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";

export const AffiliatesList = () => {
  const affiliatesQuery = useQuery({
    queryKey: ["affiliates"],
    queryFn: fetchAffiliates,
  });

  const columns = [
    {
      title: "Naam",
      dataIndex: "name",
      key: "name",
      render: (_: any, record: any) => (
        <>
          <NavLink to={`/affiliates/${record.id}`}>{record.name}</NavLink>
        </>
      ),
    },
    { title: "E-mail", dataIndex: "email", key: "email" },
    { title: "Slug", dataIndex: "slug", key: "slug" },
    {
      title: "Acties",
      key: "actions",
      render: (_: unknown, record: any) => (
        <Link to={`/affiliates/${record.id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
      ),
    },
  ];

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/affiliates/create">
          <Button icon={<PlusOutlined />}>Nieuwe affiliate</Button>
        </Link>
      </Space>
      <Table
        rowKey="id"
        dataSource={affiliatesQuery.data?.member}
        columns={columns}
        loading={affiliatesQuery.isLoading}
      />
    </div>
  );
};
